module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/hero.e6ca853ce503c7db2ea22ca39966604d.jpg";